var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.task.type ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showTaskBox,
      expression: "showTaskBox"
    }],
    staticClass: "Layer-FullScreen noticeType-Bulletbox component-task-box",
    class: {
      'show-animation': _vm.showTaskBox,
      'fade-out': _vm.showOutAnimation
    },
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.hideBox.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "main",
    on: {
      "click": function click($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('ycf-image', {
    staticClass: "top-img",
    attrs: {
      "src": "/srcv2/images/task_box_grain.png"
    }
  }), _c('div', {
    staticClass: "main-border",
    class: {
      'is-order': _vm.task.type == 2
    }
  }, [_c('div', {
    staticClass: "main-content"
  }, [_c('div', {
    staticClass: "txt-h"
  }, [_vm.task.type == 2 ? _c('div', {
    staticClass: "cel-1"
  }, [_vm.task.playMode == 1 ? [_c('ycf-image', {
    staticClass: "box-shadow",
    attrs: {
      "src": "/srcv2/images/task_box_push.png"
    }
  }), _c('span', {
    staticClass: "cel-1-txt"
  }, [_vm._v("直推")])] : _vm.task.playMode == 2 ? [_c('ycf-image', {
    attrs: {
      "src": "/srcv2/images/task_box_head.png"
    }
  }), _c('span', {
    staticClass: "cel-1-txt is-head"
  }, [_vm._v("团长")])] : _vm._e()], 2) : _vm._e(), _vm.type == 1 ? _c('span', {
    staticClass: "cel-2"
  }, [_vm._v(_vm._s(_vm.task.type == 2 ? "产品限时推广中" : "产品限时拉新中"))]) : _vm.type == 2 ? _c('span', {
    staticClass: "cel-2"
  }, [_vm._v("您已领取限时任务")]) : _vm._e()]), _vm.task.type == 2 ? _c('p', {
    staticClass: "txt-p"
  }, [_vm._v("完成推广任务共可获 "), _c('i', [_vm._v(_vm._s(_vm.task.prizeNum) + "元")]), _vm._v("奖金！"), _c('br'), _vm._v("直接提现微信钱包~快行动起来吧")]) : _vm.task.type == 3 ? _c('p', {
    staticClass: "txt-p"
  }, [_vm._v("每邀请一位新好友购买或推广指定商品奖励"), _c('br'), _c('i', [_vm._v(_vm._s(_vm.task.prizeNum) + "元")]), _vm._v(" ，直接提现微信钱包~快行动起来吧")]) : _vm._e(), _c('div', {
    staticClass: "txt-time-border"
  }, [_c('div', {
    staticClass: "txt-time-content"
  }, [_vm._v("任务时间 " + _vm._s(_vm.getFormatDate(_vm.task.beginTime)) + "至" + _vm._s(_vm.getFormatDate(_vm.task.endTime)))])]), _c('div', {
    staticClass: "btn-border",
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        _vm.type == 1 ? _vm.goTaskDetailsPage() : _vm.hideBox();
      }
    }
  }, [_c('div', {
    staticClass: "btn-content"
  }, [_c('i', [_vm._v(_vm._s(_vm.type == 1 ? "去领取" : "好的"))])])])])])], 1)]) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };